export const UrlsTypes = {
    FETCH_URLS: 'FETCH_URLS',
    SET_URLS: 'SET_URLS',
    FETCH_EXIT: 'FETCH_EXIT',
    SET_EXIT_URL: 'SET_EXIT_URL',
    ERROR_FETCH_EXIT: 'ERROR_FETCH_EXIT',
    ERROR_FETCH_URLS: 'ERROR_FETCH_URLS'
}